import { type FC } from 'react';

import { useCustomerReviews } from '@/hooks/apps/customer-review';
import { RatingItemEntity } from './RatingItem';

interface RatingProps {
    assigneeId: string;
}

const RatingList: FC<RatingProps> = ({ assigneeId }) => {
    const { data } = useCustomerReviews({
        AssigneeId: assigneeId,
        includeProperties: 'TaskCheck,Ticket,Customer',
    });

    const ratings = data?.result.items;

    return (
        <div className='flex flex-col w-full'>
            {ratings?.map((item, index) => (
                <RatingItemEntity key={index} item={item} />
            ))}
        </div>
    );
};

export default RatingList;
